import { useMediaQuery } from "@mui/material"
import { Input } from "antd"
import { FC, useEffect, useState } from "react"
import { PopupScreenSelect } from "../constant/constant"
import CustomizedColorInput from "../CreateForm/ColorBase"
import CustomizedSingleSelectDropdown from "../CreateForm/DropdownBase"
import CustomizedInput from "../CreateForm/InputBase"
import CustomizedSwitch from "../CreateForm/SwitchBase"
import { EditButton } from "../Custom/Buttons"
import { FontTitleSectionContainer } from "../CustomCss/styled"
import './style.scss'
const initial = {
  mode: "popup",
  size: "medium",
  buttonText: "click me",
  buttonColor: "#000",
  fontSize: "17",
  borderRadius: "10",
  buttonToText: false
}

interface PopupScreenComponentProps {
  setWidgetConfigDetails: any;
  widgetConfigDetails?: any;
}

const PopupScreenComponent: FC<PopupScreenComponentProps> = ({ setWidgetConfigDetails, widgetConfigDetails }) => {
  const [embedData, setEmbedData] = useState(initial)
  const [editColor, setEditColor] = useState(false)
  const isLessThan1440 = useMediaQuery("(max-width:1439px)");

  useEffect(() => {
    setWidgetConfigDetails((prev: any) => {
      return {
        ...prev,
        size: embedData.size,
        buttonText: embedData.buttonText,
        buttonColor: embedData.buttonColor,
        fontSize: embedData.fontSize.includes("px") ? `${embedData.fontSize}` : `${embedData.fontSize}px`,
        borderRadius: embedData.borderRadius.includes("%") ? `${embedData.borderRadius}` : `${embedData.borderRadius}%`,
        buttonToText: embedData.buttonToText,
      }
    })
  }, [embedData])
  useEffect(() => {
    if (widgetConfigDetails?.mode === "popup" && widgetConfigDetails?.size !== undefined && widgetConfigDetails?.buttonText !== undefined && widgetConfigDetails?.buttonColor !== undefined && widgetConfigDetails?.fontSize !== undefined && widgetConfigDetails?.borderRadius !== undefined && widgetConfigDetails?.buttonToText !== undefined) {
      setEmbedData(widgetConfigDetails)
    }
  }, [widgetConfigDetails.id])

  return (
    <div className="popupScreen">
      <div className="popupScreenSize">
        <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
          popup Size
        </FontTitleSectionContainer>
        <CustomizedSingleSelectDropdown
          value={embedData.size}
          setValue={(e: any) => setEmbedData((prev) => ({ ...prev, size: e }))}
          dataProvider={PopupScreenSelect}
        />
      </div>
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Button text
      </FontTitleSectionContainer>
      <CustomizedInput
        placeholder=""
        value={embedData.buttonText}
        onChange={(e: any) => { setEmbedData((prev) => ({ ...prev, buttonText: e.target.value })) }}
        type="text"
      />
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Button color
      </FontTitleSectionContainer>
      <div className="popupScreenButtonColor">
        <div className="popupScreenButtonColorName">
          <CustomizedColorInput
            open={editColor}
            color={embedData.buttonColor}
            closeHandler={() => setEditColor(false)}
            setColor={(value: any) => {
              setEmbedData((prev) => ({ ...prev, buttonColor: value }))
            }}
          />
          <span>{embedData.buttonColor}</span>
        </div>
        <EditButton onClick={() => setEditColor(true)}
          variant="contained"
          size="small" />
      </div>
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Font size(px)
      </FontTitleSectionContainer>
      <div className="popupScreenFontSize">
        <Input name="fontsize" type="range" min="14" max="32" className="popupRange"
          onChange={(e) => setEmbedData((prev) => ({ ...prev, fontSize: e.target.value }))}
          value={embedData.fontSize}
        />
        <CustomizedInput
          style={{ width: 101 }}
          placeholder=""
          onChange={(e: any) => setEmbedData((prev) => ({ ...prev, fontSize: e.target.value }))}
          value={embedData.fontSize} inputProps={{ min: 14, max: 32 }}
          type="number"
        />
      </div>
      <FontTitleSectionContainer isLargeScreen={!isLessThan1440}>
        Rounded corners(%)
      </FontTitleSectionContainer>
      <div className="popupScreenBorderRadius">
        <Input type="range" min="0" max="100" name="buttonRadius" className="popupRange"
          value={embedData.borderRadius}
          onChange={(e) => setEmbedData((prev) => ({ ...prev, borderRadius: e.target.value }))}
        />
        <CustomizedInput
          style={{ width: 101 }}
          placeholder=""
          value={embedData.borderRadius}
          onChange={(e: any) => setEmbedData((prev) => ({ ...prev, borderRadius: e.target.value }))}
          inputProps={{ min: 0, max: 100 }}
          type="number"
        />
      </div>
      <div className="popupScreenButtonTOText">
        <FontTitleSectionContainer isLargeScreen={!isLessThan1440} className="popupScreenButtonTOTextLabel" >
          Change button to text
        </FontTitleSectionContainer>
        <CustomizedSwitch
          checked={embedData.buttonToText}
          changeHandler={(e: React.ChangeEvent<HTMLInputElement>) =>
            setEmbedData(prev => ({ ...prev, buttonToText: e.target.checked }))
          }
        />
      </div>
    </div>
  )
}

export default PopupScreenComponent